import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware, routerReducer } from 'react-router-redux';

import rootSaga from './sagas';

import { default as activities } from 'activities';
import { default as affiliates } from 'affiliates';
import { default as advanced } from 'advanced';
import { default as manual } from 'manual';
import { default as experiment } from 'experiment';
import { default as boundaries } from 'boundaries';
import { default as crops } from 'crops';
import { default as current } from 'current';
import { default as devices } from 'devices';
import { default as exportSelector } from 'export-selector';
import { default as farms } from 'farms';
import { default as fieldViewUsers } from 'fieldview-users';
import { default as fields } from 'fields';
import { default as legends } from 'legends';
import { default as loading } from 'loading';
import { default as messages } from 'messages';
import { default as operations } from 'operations';
import { default as plantingPlan } from 'planting-plan-form';
import { default as plantings } from 'planting';
import { default as preload } from 'api/loading';
import { default as productFeatures } from 'product-features';
import { default as products } from 'products';
import { default as scenarios } from 'advanced/scenarios';
import { default as scripts } from 'scripts';
import { default as settings } from 'settings';
import { default as uiwidgets } from 'current/uiwidgets';
import { default as user } from 'user';
import { default as imagery } from 'imagery';
import { default as seedProductSelector } from 'edit/seed-product-selector';
import { default as validations } from 'validations';
import { default as scriptFlow } from 'script-flow';
import { default as seasons } from 'seasons';
import { default as trialPlacementOptions } from 'trial-placements';

import featureFlags from 'store/launchDarkly/reducer';

export const initStore = ({ history }) => {

  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: {
      routing: routerReducer,
      activities,
      affiliates,
      advanced,
      manual,
      experiment,
      boundaries,
      crops,
      current,
      devices,
      exportSelector,
      farms,
      fieldViewUsers,
      launchDarkly: featureFlags,
      fields,
      legends,
      imagery,
      loading,
      messages,
      operations,
      plantingPlan,
      plantings,
      preload,
      productFeatures,
      products,
      scenarios,
      scriptFlow,
      scripts,
      seasons,
      seedProductSelector,
      settings,
      trialPlacementOptions,
      uiwidgets,
      user,
      validations
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      // We need to disable this for now, while we begin to refactor reducers in to slices.
      serializableCheck: false,
      immutableCheck: false
    }).concat([sagaMiddleware, routerMiddleware(history)])
  });
  sagaMiddleware.run(rootSaga);
  return store;
};
